import RebetLoader from "../RebetLoader/RebetLoader";

import "./stylesSaveButton.css";

/**
 * @deprecated For new code, compose `Button` from `components/shared`:
 *   <Button intent="ghost" onClick={cancel}>Cancel</Button>
 *   <Button intent="primary" loading={isApiRunning} onClick={save}>{label}</Button>
 *
 * Existing `SaveButton` consumers stay functional — migration is deferred
 * to a cleanup wave where each consumer is visually verified (this widget
 * has its own visual contract distinct from antd Button).
 */
function SaveButton({
  isApiRunning,
  callbackFunction,
  buttonText = "Save",
  cancelButton = false,
  cancelButtonText = "",
  callbackFunctionCancel = null,
  isDisabled = false,
}) {
  return (
    <div
      className="save-buttons-container"
      style={
        !cancelButton
          ? { justifyContent: "center" }
          : { justifyContent: "space-between" }
      }
    >
      {cancelButton && (
        <button
          className="cancel-button"
          onClick={callbackFunctionCancel}
          disabled={isApiRunning}
        >
          {cancelButtonText}
        </button>
      )}
      <button
        className={`save-button ${isApiRunning ? "saving" : ""} ${isDisabled ? "disabled" : ""}`}
        disabled={isApiRunning || isDisabled}
        onClick={callbackFunction}
      >
        {isApiRunning ? (
          <RebetLoader height={"20px"} width={"20px"} />
        ) : (
          buttonText
        )}
      </button>
    </div>
  );
}

export default SaveButton;
